/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for non-detect data grouped by provider.
 * @export
 * @interface ProviderNonDetects
 */
export interface ProviderNonDetects {
    /**
     * Data provider UUID
     * @type {string}
     * @memberof ProviderNonDetects
     */
    dataProvider: string;
    /**
     * Data provider name
     * @type {string}
     * @memberof ProviderNonDetects
     */
    dataProviderName: string;
    /**
     * Secondary data source name
     * @type {string}
     * @memberof ProviderNonDetects
     */
    secondaryDataSource: string | null;
    /**
     * Number of non-detect records
     * @type {number}
     * @memberof ProviderNonDetects
     */
    count: number;
}

/**
 * Check if a given object implements the ProviderNonDetects interface.
 */
export function instanceOfProviderNonDetects(value: object): value is ProviderNonDetects {
    if ((!('dataProvider' in (value as Record<string, any>)) && !('data_provider' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProvider'] === undefined && (value as Record<string, any>)['data_provider'] === undefined)) return false;
    if ((!('dataProviderName' in (value as Record<string, any>)) && !('data_provider_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProviderName'] === undefined && (value as Record<string, any>)['data_provider_name'] === undefined)) return false;
    if ((!('secondaryDataSource' in (value as Record<string, any>)) && !('secondary_data_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['secondaryDataSource'] === undefined && (value as Record<string, any>)['secondary_data_source'] === undefined)) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ProviderNonDetectsFromJSON(json: any): ProviderNonDetects {
    return ProviderNonDetectsFromJSONTyped(json, false);
}

export function ProviderNonDetectsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderNonDetects {
    if (json == null) {
        return json;
    }
    return {
        
        'dataProvider': json['data_provider'],
        'dataProviderName': json['data_provider_name'],
        'secondaryDataSource': json['secondary_data_source'],
        'count': json['count'],
    };
}

export function ProviderNonDetectsToJSON(json: any): ProviderNonDetects {
    return ProviderNonDetectsToJSONTyped(json, false);
}

export function ProviderNonDetectsToJSONTyped(value?: ProviderNonDetects | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_provider': value['dataProvider'],
        'data_provider_name': value['dataProviderName'],
        'secondary_data_source': value['secondaryDataSource'],
        'count': value['count'],
    };
}

